import { useTranslation } from "react-i18next";
import { ProcessedListingData } from "../../../@types/sharedSchema";
import { Stack, Typography } from "@material-ui/core";

export function ListingLocationDetails({
  listing
}: {
  listing: ProcessedListingData;
}): JSX.Element {
  const { t: translate } = useTranslation();

  const { locationDetails } = listing;

  return (
    <Stack gap={1}>
      <Typography variant="h5">{translate("listingsDetails.locationDetails")}</Typography>
      <Typography variant="body1">{locationDetails}</Typography>
    </Stack>
  );
}
